export type DeviceGroup = {
  brand: string
  devices: string[]
}

export type ManufacturerSection = {
  manufacturer: string
  groups: DeviceGroup[]
}

export const esimDevices: ManufacturerSection[] = [
  {
    manufacturer: 'Apple',
    groups: [
      {
        brand: 'iPhone',
        devices: [
          'iPhone 17e',
          'iPhone Air',
          'iPhone 17 Pro Max',
          'iPhone 17 Pro',
          'iPhone 17',
          'iPhone 16 Pro Max',
          'iPhone 16 Pro',
          'iPhone 16 Plus',
          'iPhone 16e',
          'iPhone 15 Pro Max',
          'iPhone 15 Pro',
          'iPhone 15 Plus',
          'iPhone 15',
          'iPhone 14 Pro Max',
          'iPhone 14 Pro',
          'iPhone 14 Plus',
          'iPhone 14',
          'iPhone 13 Pro Max',
          'iPhone 13 Pro',
          'iPhone 13',
          'iPhone 13 mini',
          'iPhone SE (3rd Gen)',
          'iPhone 12 Pro Max',
          'iPhone 12 Pro',
          'iPhone 12',
          'iPhone 12 mini',
          'iPhone SE 2020',
          'iPhone 11 Pro Max',
          'iPhone 11 Pro',
          'iPhone 11',
          'iPhone XR',
          'iPhone XS Max',
          'iPhone XS',
        ],
      },
    ],
  },
  {
    manufacturer: 'Samsung',
    groups: [
      {
        brand: '',
        devices: [
          'Galaxy S26 Ultra',
          'Galaxy S26+',
          'Galaxy S26',
          'Galaxy S25 Ultra',
          'Galaxy S25+',
          'Galaxy S25',
          'Galaxy S25 Edge',
          'Galaxy S24 Ultra',
          'Galaxy S24+',
          'Galaxy S24 FE',
          'Galaxy S24',
          'Galaxy Z Flip5',
          'Galaxy Z Fold5',
          'Galaxy Z Flip6',
          'Galaxy Z Fold6',
          'Galaxy Z Fold7',
          'Galaxy Z Flip7',
          'Galaxy Z Flip 7 FE',
          'Galaxy A56',
          'Galaxy A55 5G',
          'Galaxy A54 5G',
          'Galaxy A35 5G',
          'Galaxy A36',
          'Galaxy Fold 5G',
          'Galaxy Note 20 5G',
          'Galaxy Note 20 Ultra 5G',
          'Galaxy S20',
          'Galaxy S20 5G',
          'Galaxy S20+',
          'Galaxy S20 Ultra 5G',
          'Galaxy S21 Ultra 5G',
          'Galaxy S21+ 5G',
          'Galaxy S21 5G',
          'Galaxy S22 5G',
          'Galaxy S22 Ultra',
          'Galaxy S22+',
          'Galaxy S23 5G',
          'Galaxy S23 Ultra',
          'Galaxy S23+',
          'Galaxy S23 FE',
          'Galaxy Z Flip',
          'Galaxy Z Flip 5G',
          'Galaxy Z Flip 3 5G',
          'Galaxy Z Flip 4 5G',
          'Galaxy Z Fold 2 5G',
          'Galaxy Z Fold 3 5G',
          'Galaxy Z Fold 4',
        ],
      },
    ],
  },
  {
    manufacturer: 'Google',
    groups: [
      {
        brand: '',
        devices: [
          'Pixel 10 Pro Fold',
          'Pixel 10 Pro XL',
          'Pixel 10 Pro',
          'Pixel 10',
          'Pixel 9 Pro XL',
          'Pixel 9 Pro Fold',
          'Pixel 9 Pro',
          'Pixel 9',
          'Pixel 9a',
          'Pixel 8a',
          'Pixel 8 Pro',
          'Pixel 8',
          'Pixel Fold',
          'Pixel 7a',
          'Pixel 7 Pro',
          'Pixel 7',
          'Pixel 6a',
          'Pixel 6 Pro',
          'Pixel 6',
          'Pixel 5',
          'Pixel 4 XL',
          'Pixel 4a',
          'Pixel 4',
          'Pixel 3a XL',
          'Pixel 3a',
          'Pixel 3 XL',
          'Pixel 3',
        ],
      },
    ],
  },
  {
    manufacturer: 'Other',
    groups: [
      {
        brand: 'Fairphone',
        devices: ['Fairphone 6', 'Fairphone 5', 'Fairphone 4'],
      },
      {
        brand: 'HUAWEI',
        devices: [
          'Huawei Pura 70 Pro',
          'Huawei Mate 40 Pro',
          'Huawei P40 Pro',
          'Huawei P40',
        ],
      },
      {
        brand: 'HONOR',
        devices: [
          '400 Pro',
          '400',
          '400 Lite',
          'Magic7 Lite',
          'Magic7 Pro',
          '200 Pro',
          'Magic6 Pro',
          'Magic6 Pro RSR',
          'Magic Vs',
          'Magic Vs3',
          'Magic V2',
          'Magic V3',
          'Magic5 Pro',
          'Magic4 Pro',
        ],
      },
      {
        brand: 'Motorola',
        devices: [
          'Razr 60 Ultra',
          'Razr 50 Ultra',
          'Razr 50',
          'Razr 40 Ultra',
          'Razr 40',
          'Edge 50 Ultra',
          'Edge 50 Pro',
          'Edge 50 Fusion',
          'Edge 50 Neo',
          'Edge 50',
          'Edge 40 Pro',
          'Edge 40 Neo',
          'Edge 40',
        ],
      },
      {
        brand: 'OPPO',
        devices: ['Find X3 Pro', 'Find X5 Pro', 'Find X5', 'Find N2 Flip 5G'],
      },
      {
        brand: 'Sony',
        devices: [
          'Xperia 1 VII',
          'Xperia 1 VI',
          'Xperia 1 V',
          'Xperia 1 IV',
          'Xperia 5 V',
          'Xperia 5 IV',
          'Xperia 10 VI',
          'Xperia 10 V',
          'Xperia 10 IV',
        ],
      },
      {
        brand: 'Xiaomi',
        devices: ['Mi 12T Pro'],
      },
      {
        brand: 'Nokia',
        devices: ['XR21', 'X30', 'G60 5G'],
      },
    ],
  },
]
